import { type TFunction } from "i18next";
import { z } from "zod";

// TODO: Missing translations for error messages

export const createLoginFormSchema = (t: TFunction) => {
  return z.object({
    loginId: z.string().min(
      1,
      t("invalid_field_error", {
        "0": t("login_id"),
      })
    ),
    pin: z.string().min(1, ""),
  });
};

export type LoginFormSchema = z.infer<ReturnType<typeof createLoginFormSchema>>;

export const createRegisterFormSchema = (t: TFunction) => {
  const baseSchema = {
    loginId: z.string().min(
      1,
      t("invalid_field_error", {
        "0": t("login_id"),
      })
    ),
    yearOfBirth: z
      .string()
      .min(4, "")
      .max(4, "")
      .refine(
        (val) => /^\d{4}$/.test(val),
        t("invalid_field_error", {
          "0": t("auth_accountActivation_dateOfBirth"),
        })
      ),
    pin: z
      .string({ message: t("choosePin_subtitle") })
      .min(6, t("choosePin_subtitle")),
    confirmPin: z
      .string({ message: t("choosePin_subtitle") })
      .min(6, t("choosePin_subtitle")),
    contracts: z
      .record(
        z.string(),
        z.boolean({ message: "" }).refine((value) => value === true, {
          message: "",
        })
      )
      .default({}),
  };

  return z.object(baseSchema).refine((data) => data.pin === data.confirmPin, {
    message: t("error_notMatchedPin"),
    path: ["confirmPin"],
  });
};

export type RegisterFormSchema = z.infer<
  ReturnType<typeof createRegisterFormSchema>
>;

export type AuthFormSchema = LoginFormSchema | RegisterFormSchema;
